mutation CardHolderCreate($input: CardHolderCreateInput!) {
  cardHolderCreate(input: $input) {
    clientMutationId
    cardHolder {
      id
    }
  }
}
